var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLCardBody",
    { staticClass: "tenancy-document__wrapper no-padding no-shadow" },
    [
      _c(
        "Collapse",
        {
          staticClass:
            "tenancy-info__collapse title-font14 overflow-hide-content",
          attrs: {
            title: _vm.$t("tenancy.documentSubmission"),
            expand: true,
            withBorder: false,
          },
        },
        [
          _c(
            "template",
            { slot: "content" },
            [
              _c("TenancyDocumentRemarksVue"),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "a-col",
                    { attrs: { flex: "1" } },
                    [
                      _c("label", [_vm._v(_vm._s(_vm.$t("documents")))]),
                      _vm._v(" "),
                      _vm.hasUpdateRemarksAndDocsAccess
                        ? _c("HkldDropzone", {
                            attrs: {
                              metaData: { uploadOnTop: true },
                              sourceId: _vm.docSourceId,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("EditAttachments", {
                        attrs: {
                          showEditPencil: _vm.showEditPencilFunc,
                          canDelete: _vm.hasUpdateRemarksAndDocsAccess,
                          showAllDeleteBtn: false,
                          uploadOnTop: true,
                          sortingToggle: true,
                          sourceId: _vm.docSourceId,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }